import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-up-light.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-down-light.svg'
import _imports_3 from '@/app/ui/assets/svg/chevron-down-black.svg'


const _hoisted_1 = { class: "flex flex-row items-center justify-end w-full" }
const _hoisted_2 = { class: "flex flex-row z-20 items-center" }
const _hoisted_3 = { class: "float-left pl-18 pt-3 pr-4" }
const _hoisted_4 = { class: "ml-1 relative" }
const _hoisted_5 = { class: "text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_6 = { class: "text-20px text-red-lp-100 font-bold" }
const _hoisted_7 = { class: "float-right pt-3 pl-4" }
const _hoisted_8 = {
  key: 1,
  class: "items-center w-36 cursor-pointer"
}
const _hoisted_9 = { class: "text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-20px text-red-lp-100 font-bold" }, " IDR - ", -1)
const _hoisted_11 = {
  key: 0,
  class: "\n      absolute\n      border-l\n      z-10\n      border-r\n      flex flex-col\n      bg-gray-lp-700\n      rounded-bl rounded-br\n      shadow\n      w-full\n      -mr-8\n    ",
  style: {"margin-bottom":"360px","box-shadow":"0px -5px 5px -1px #e0e0e0"}
}
const _hoisted_12 = { class: "border-b border-gray-lp-700 py-4" }
const _hoisted_13 = { class: "flex flex-row justify-between ml-4 mr-8" }
const _hoisted_14 = { class: "font-semibold text-20px pr-48 pl-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "",
  class: "cursor-pointer"
}, null, -1)
const _hoisted_16 = { class: "\n        flex flex-row\n        justify-between\n        mx-8\n        border-t border-b border-black-lp-300\n      " }
const _hoisted_17 = { class: "border-b border-gray-lp-700 py-4" }
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = { class: "\n              text-gray-lp-600 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex-col flex\n            " }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "pt-4 font-semibold" }, "City Rate", -1)
const _hoisted_21 = { class: "pt-2" }
const _hoisted_22 = { class: "\n              text-gray-lp-600 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex-col flex\n            " }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold" }, "Forward Rate", -1)
const _hoisted_24 = { class: "pt-2" }
const _hoisted_25 = { class: "\n              text-gray-lp-600 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex-col flex\n            " }
const _hoisted_26 = { class: "pt-8 font-semibold text-black-lp-300" }
const _hoisted_27 = { class: "flex flex-row space-x-2" }
const _hoisted_28 = { class: "pt-2 text-black-lp-300" }
const _hoisted_29 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "pt-4 font-semibold" }, "COD Amount", -1)
const _hoisted_33 = { class: "pt-2" }
const _hoisted_34 = { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "pt-8 font-semibold" }, "COD Fee", -1)
const _hoisted_36 = { class: "pt-2" }
const _hoisted_37 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_38 = { class: "flex flex-col" }
const _hoisted_39 = { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_40 = { class: "pt-4 font-semibold" }
const _hoisted_41 = { class: "pt-2" }
const _hoisted_42 = { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_43 = { class: "pt-8 font-semibold" }
const _hoisted_44 = { class: "pt-2" }
const _hoisted_45 = { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_46 = { class: "pt-8 font-semibold" }
const _hoisted_47 = { class: "pt-2" }
const _hoisted_48 = { class: "border-b border-gray-lp-400 py-4 pr-6" }
const _hoisted_49 = { class: "flex flex-col" }
const _hoisted_50 = { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_51 = { class: "pt-4 font-semibold" }
const _hoisted_52 = {
  key: 0,
  class: "text-black-lp-200 ml-1"
}
const _hoisted_53 = { class: "\n                    rounded\n                    px-2\n                    py-0\n                    bg-gray-lp-400\n                    text-12px\n                    xxl:text-14px\n                  " }
const _hoisted_54 = { class: "capitalize" }
const _hoisted_55 = { class: "pt-2" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "\n              text-black-lp-300 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }, null, -1)
const _hoisted_57 = { class: "\n              text-black-lp-200 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_58 = { class: "pt-8 font-semibold" }
const _hoisted_59 = { class: "pt-2" }
const _hoisted_60 = { class: "\n              text-gray-lp-600 text-12px\n              xxl:text-14px\n              float-left\n              pl-4\n              flex flex-col\n            " }
const _hoisted_61 = { class: "pt-8 font-semibold" }
const _hoisted_62 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        (_ctx.shipmentDetail.sttBookedForType === 'pos')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "",
                    message: _ctx.$t('Perbarui Harga'),
                    footer: "",
                    isArrowBottom: false,
                    isArrowRight: "",
                    style: {"width":"150px","margin-top":"-1em","margin-left":"-14em"}
                  }, null, 8, ["message"]), [
                    [_vShow, _ctx.isOpenTooltip]
                  ]),
                  _createVNode("img", {
                    alt: "",
                    class: "cursor-pointer",
                    src: _imports_0,
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenTooltip(true))),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenTooltip(false))),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getEstimationPrice && _ctx.getEstimationPrice(...args)))
                  }, null, 32)
                ])
              ]),
              _createVNode("div", {
                class: "items-center w-36 cursor-pointer",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
              }, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Total Tarif')), 1),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.currency(_ctx.dataDetail.totalTariff)), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("img", {
                  alt: "",
                  class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'}`,
                  src: _imports_1,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                }, null, 2),
                _createVNode("img", {
                  alt: "",
                  class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''}`,
                  src: _imports_2,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
                }, null, 2)
              ])
            ], 64))
          : (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Total Tarif')), 1),
              _hoisted_10
            ])),
        _createVNode(_component_LpButton, {
          title: _ctx.$t('Simpan Perubahan'),
          textColor: "white",
          onClick: _ctx.onSave,
          class: "pl-5",
          disabled: _ctx.disabledSubmit
        }, null, 8, ["title", "onClick", "disabled"])
      ], 512), [
        [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
      ])
    ]),
    (_ctx.isShow)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('Detail Pembayaran')), 1),
              _hoisted_15
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.currency(_ctx.dataDetail.cityRates)), 1)
                ]),
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.currency(_ctx.dataDetail.forwardRates)), 1)
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('Biaya Pengiriman')), 1),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.currency(_ctx.dataDetail.shippingCost)), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode("div", _hoisted_33, _toDisplayString(_ctx.currency(_ctx.dataDetail.codAmount)), 1)
                ]),
                _createVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode("div", _hoisted_36, _toDisplayString(_ctx.currency(_ctx.dataDetail.codFee)), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('Biaya Tambahan Komoditas')), 1),
                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.currency(_ctx.dataDetail.commoditySurcharge)), 1)
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('Biaya Tambahan Berat')), 1),
                  _createVNode("div", _hoisted_44, _toDisplayString(_ctx.currency(_ctx.dataDetail.heavyWeightSurcharge)), 1)
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('Biaya Tambahan Dokumen')), 1),
                  _createVNode("div", _hoisted_47, _toDisplayString(_ctx.currency(_ctx.dataDetail.documentSurcharge)), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Asuransi')) + " ", 1),
                    (_ctx.dataDetail.insuranceName)
                      ? (_openBlock(), _createBlock("span", _hoisted_52, [
                          _createVNode("span", _hoisted_53, [
                            _createVNode("span", _hoisted_54, _toDisplayString(_ctx.dataDetail.insuranceName.replace("Insurance", "")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_55, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceRates - _ctx.dataDetail.insuranceAdminFee)), 1)
                ]),
                _hoisted_56,
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('Biaya Admin')), 1),
                  _createVNode("div", _hoisted_59, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceAdminFee)), 1)
                ]),
                _createVNode("div", _hoisted_60, [
                  _createVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('Est. Pajak')), 1),
                  _createVNode("div", _hoisted_62, _toDisplayString(_ctx.currency(_ctx.dataDetail.taxRates)), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}